/** Alinhado a api/constants/entregaStatus.js e DynamicSelector */
export const ENTREGA_AGENDADA = "Entrega Agendada";
export const SAIU_PARA_ENTREGA = "Saiu para Entrega";
export const PEDIDO_ENTREGUE = "Pedido Entregue";
export const PEDIDO_NAO_ENTREGUE = "Pedido Não Entregue";

export const LISTA_SITUACOES = [
	ENTREGA_AGENDADA,
	SAIU_PARA_ENTREGA,
	PEDIDO_ENTREGUE,
	PEDIDO_NAO_ENTREGUE,
];

/** Classe CSS tipo `.pay*` em tabelas (alinhado a pedidos). */
export function entregaStatusPayClass(status) {
	if(!status) return "payEntregaOutro";
	const map = {
		[ENTREGA_AGENDADA]: "payEntregaAgendada",
		[SAIU_PARA_ENTREGA]: "paySaiuParaEntrega",
		[PEDIDO_ENTREGUE]: "payPedidoEntregue",
		[PEDIDO_NAO_ENTREGUE]: "payPedidoNaoEntregue",
		"Cancelado pela loja": "payCanceladoLoja",
	};
	return map[status] || "payEntregaOutro";
}

/** Texto curto na listagem: distingue agendada sem lote × com lote. */
export function entregaStatusListagemLabel(entrega) {
	if(!entrega || !entrega.status) return "—";
	if(entrega.status === ENTREGA_AGENDADA && entrega.loteAtual){
		return "Agendada · lote";
	}
	return entrega.status;
}

/** Classe CSS na listagem (considera lote em Entrega Agendada). */
export function entregaStatusListagemPayClass(entrega) {
	if(!entrega || !entrega.status) return "payEntregaOutro";
	if(entrega.status === ENTREGA_AGENDADA && entrega.loteAtual){
		return "payEntregaAgendadaComLote";
	}
	return entregaStatusPayClass(entrega.status);
}
